import { useTheme } from '@mui/material';
import { ScreenSizes } from '@interfaces';

export const useStyles = () => {
  const { breakpoints } = useTheme();

  return {
    root: {
      display: 'grid',
      gap: 2,
      width: 360,
      maxWidth: '100%',
      padding: '20px',
      transition: 'all 0.2s ease',
      [breakpoints.down(ScreenSizes.TabletHorizontal)]: {
        display: 'flex',
        flexDirection: 'column',
        height: 'calc(100vh - 86px)',
        maxHeight: 'calc(100dvh - 86px)',
        maxWidth: 'unset',
        padding: '12px 16px',
        gap: 1.5,
      },
    },
    tabContent: {
      height: 269,
      [breakpoints.down(ScreenSizes.TabletHorizontal)]: {
        height: '42vh',
        maxHeight: '42dvh',
      },
    },
    content: {
      height: '100%',
      flexGrow: 1,

      // [breakpoints.down(ScreenSizes.TabletHorizontal)]: {
      //   height: 'auto',
      // },
    },
  };
};
